// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var getKioskAwareUrl = function (defaultUrl, kioskUrl, isKiosk) { return (isKiosk && (kioskUrl === null || kioskUrl === void 0 ? void 0 : kioskUrl.trim()) ? kioskUrl.trim() : defaultUrl); };
export var getKioskPortalRedirectUrl = function (currentUrl, kioskPortalUrl, isKiosk) {
    if (!isKiosk || !(kioskPortalUrl === null || kioskPortalUrl === void 0 ? void 0 : kioskPortalUrl.trim())) {
        return null;
    }
    var current = new URL(currentUrl);
    var target = new URL(kioskPortalUrl.trim());
    if (current.origin === target.origin) {
        return null;
    }
    target.pathname = current.pathname;
    target.search = current.search;
    target.hash = current.hash;
    return target.toString();
};
